import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {SisrhService} from '@app/services/sisrh.service';

@Component({
  templateUrl: './vaga-participar-entrevista.page.html',
  styles: ['#declaracao { font-size: 1.6em; color: red; font-weight: bold; margin-left: 10px;}']
})

export class VagaParticiparEntrevistaPage implements OnInit {

  public vagas: any[];
  public candidatos: any;
  public formulario: FormGroup;
  public idEntrevistaVaga: string;
  public confirmacaoDeclaracaoCheckBox: boolean;
  mostrarConteudo = false;

  questoes: any[];
  questao: any;

  constructor(
    private _route: ActivatedRoute,
    private sisrhService: SisrhService,
    private _fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(x => this.idEntrevistaVaga = x.idEntrevistaVaga);

    this.recuperarDadosIniciais();
    this.candidatos = [];
    this.vagas = [];
    this.questoes = [];

    this.formulario = this._fb.group({
      confirmacaoDeclaracao: ['', Validators.required],
    });
  }

  recuperarDadosIniciais() {
    if (this.idEntrevistaVaga) {
      this.sisrhService.BuscarDadosCandidatosVaga(this.idEntrevistaVaga).subscribe(
        data => {
          console.log(data);
          this.candidatos.push({
            'cpf': data.cpfCandidato,
            'nome': data.nomeCandidato
          });
          this.vagas.push({
            'uf': data.unidadeUf,
            'lotacao': data.unidadeTitulo,
            'codigoVaga': data.codigoVaga,
            'cargo': data.cargoTitulo
          });
        });
      this.sisrhService.BuscarQuestoesEntrevistaVaga(this.idEntrevistaVaga).subscribe(
        data => {
          console.log(data);
          this.questoes = data;
          console.log(this.questoes);
        });
    }
  }

  mascaraCPF(cpf: string): string {
    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return cpf;
  }

}
